export default function(state = {}, action){
    switch(action.type){
        case "ON_SUBMIT_COMMENT": 
            return {...state, ON_SUBMIT_COMMENT: action.payload }
        default: 
            return state;      
    }
}
